import React, { useEffect, useState } from "react"; 
import { Modal } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { getSubjectByID } from "../../../../Services/Subjects/SubjectServices";
import { toast } from 'react-toastify';
import { getEnvUrl } from "../../../../utils/Api";

const ViewSubject = ({ isShow, close, subjectId }) => {  
  const handleClose = () => {
    setShow(false);
    close();
  };

  const [show, setShow] = useState(false);
  const [subjectName, setSubjectName] = useState("");
  const [preview, setPreview] = useState(null);

  useEffect(() => { 
    setShow(isShow);
    
    const fetchSubjectDetails = async () => {
      try {
        if (subjectId) {
          const response = await getSubjectByID(subjectId);
          if (response?.status) {
            setSubjectName(response.data.name || "N/A");
            setPreview(`${getEnvUrl()}/subject/getSubjecticon?id=${response.data.id}`);
          } else {
            toast.error("Failed to fetch subject details");
          }
        }
      } catch (error) {
        console.error("Error fetching subject details:", error);
        toast.error("Error fetching subject details");
      }
    };

    fetchSubjectDetails();
  }, [isShow, subjectId]); 

  return ( 
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <h5 className="modal-title">Subject Details</h5>
      </Modal.Header>
      <Modal.Body>
        <div className="row g-3">
          <div className="col-12 px-3">
            <label className="form-label"><b>Name : </b></label>
            <span className="ms-2">{subjectName}</span>
          </div>
          <div className="col-12 px-3">
            <label className="form-label"><b>Icon : </b></label>
            {preview ? (
              <img src={preview} alt="Subject Icon" className="img-thumbnail ms-12" style={{ maxWidth: '300px', maxHeight: '300px' }} />
            ) : (
              <span className="ms-2">No icon available</span>
            )}
          </div>
        </div>        
      </Modal.Body>
    </Modal>
  );
};

export default ViewSubject;
